Application.Signature.WallpaperEditor.Transformer = {
    ui: {
        container: '.step-wallpaper-editor__preview .preview',
        canvas: '.step-wallpaper-editor__preview .preview__content',
        transformer: '.preview__logo-transform',
        transformerImg: '.preview__logo-transform-img',
        ui: '.img-transform__ui',
        move: '.img-transform__move',
        resize: '.img-transform__resize',
        open: '.preview__edit',
        save: '.preview__save'
    },
    handlers: {
        move: [],
        resize: [],
        stop: []
    },
    wallpaperEditor: null,
    colorRestriction: false,
    colorRestrictionImage: false,
    colorRestrictionCanvas: null,
    scale: 1,
    state: {
        left: null,
        top: null,
        width: null
    },
    padding: 0.025,
    ready: function (wallpaperEditor) {

        this.wallpaperEditor = wallpaperEditor;

        // bind
        this.bind();

        // auto start
        this.start();

    },
    bind: function(){

        var self = this;

        // open editor
        $(document).on('click', this.ui.open, function(event){
            event.preventDefault();
            self.start();
        });

        // close editor
        $(document).on('click', this.ui.save, function(event){
            event.preventDefault();
            self.stop();
        });

        // move
        $(document).on('mousedown', this.ui.move, self.onMoveStart.bind(this));
        $(document).on('touchstart', this.ui.move, self.onMoveStart.bind(this));

        // resize
        $(document).on('mousedown', this.ui.resize, self.onResizeStart.bind(this));
        $(document).on('touchstart', this.ui.resize, self.onResizeStart.bind(this));

    },
    onMoveStart: function(event){

        var self = this;

        // event
        event.preventDefault();

        // state
        var x = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
        var y = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);

        // handlers
        var move = function(event){
            var x1 = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
            var y1 = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);
            // call
            self.move((x - x1) / self.scale, (y - y1) / self.scale);
        };
        var moveEnd = function(){
            $(document).off('mousemove', move);
            $(document).off('touchmove', move);
            $(document).off('mouseup', moveEnd);
            $(document).off('touchend', moveEnd);
            // commit
            self.moveCommit()
        };

        // bind
        $(document).on('mousemove', move);
        $(document).on('touchmove', move);
        $(document).on('mouseup', moveEnd);
        $(document).on('touchend', moveEnd);

    },
    onResizeStart: function(event){

        var self = this;

        // event
        event.preventDefault();

        // state
        var x = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
        var y = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);

        // direction
        var direction = $(event.target).data('direction');

        // handlers
        var resize = function(event){
            var x1 = event.pageX ? event.pageX : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageX : 0);
            var y1 = event.pageY ? event.pageY : (typeof event.originalEvent.touches[0] !== 'undefined' ? event.originalEvent.touches[0].pageY : 0);
            // call
            self.resize(direction, (x - x1) / self.scale, (y - y1) / self.scale);
        };
        var resizeEnd = function(){
            $(document).off('mousemove', resize);
            $(document).off('touchmove', resize);
            $(document).off('mouseup', resizeEnd);
            $(document).off('touchend', resizeEnd);
            // commit
            self.resizeCommit()
        };

        // bind
        $(document).on('mousemove', resize);
        $(document).on('touchmove', resize);
        $(document).on('mouseup', resizeEnd);
        $(document).on('touchend', resizeEnd);

    },
    start: function(){

        // change state
        $(this.ui.container).addClass('preview_editing');

    },
    stop: function(){

        // change state
        $(this.ui.container).removeClass('preview_editing');

        // handlers
        this.trigger('stop');

    },
    setBackground: function(src){

        var $img = $('<img>').attr('src', src);

        // change state
        $(this.ui.transformerImg).empty().append($img);

    },

    move: function(x, y){

        // elements
        var $canvas = $(this.ui.canvas);
        var $logo = $(this.ui.transformerImg);
        var $transformer = $(this.ui.transformer);

        // set base values
        if (!$transformer.data('resize-base-initiated')){
            $transformer.data('resize-base-initiated', true);
            $transformer.data('resize-base-x', parseFloat($transformer.css('left')));
            $transformer.data('resize-base-y', parseFloat($transformer.css('top')));
            $transformer.data('resize-base-w', $logo.width());
            $transformer.data('resize-base-h', $logo.height());
        }

        // retrieve current values
        var left = $transformer.data('resize-base-x');
        var top = $transformer.data('resize-base-y');
        var logoWidth = $transformer.data('resize-base-w');
        var logoHeight = $transformer.data('resize-base-h');

        // calculate min padding size;
        var padding = $canvas.outerWidth() * this.padding;

        // do not allow to pass the edge values
        var newX = left - x;
        newX = newX < padding ? padding : newX;
        newX = newX + logoWidth >= $canvas.outerWidth() - padding ? $canvas.outerWidth()- padding - logoWidth - 1 : newX;
        var newY = top - y;
        newY = newY < padding ? padding : newY;
        newY = newY + logoHeight >= $canvas.outerHeight() - padding ? $canvas.outerHeight() - padding - logoHeight - 1 : newY;

        // check background
        if (!this.isBackgroundAllowed(newX, newY, logoWidth, logoHeight)){
            return false;
        }

        // update
        $(this.ui.transformer).css({
            left: newX + 'px',
            top: newY + 'px'
        });

        // handlers
        this.trigger('move', [newX, newY]);

    },
    resize: function(direction, x, y){

        // elements
        var $canvas = $(this.ui.canvas);
        var $logo = $(this.ui.transformerImg);
        var $transformer = $(this.ui.transformer);

        // set base values
        if (!$transformer.data('resize-base-initiated')){
            $transformer.data('resize-base-initiated', true);
            $transformer.data('resize-base-x', parseFloat($transformer.css('left')));
            $transformer.data('resize-base-y', parseFloat($transformer.css('top')));
            $transformer.data('resize-base-w', $transformer.width());
            $transformer.data('resize-base-h', $transformer.height());
        }
        // retrieve base values
        var left = $transformer.data('resize-base-x');
        var top = $transformer.data('resize-base-y');
        var width = $transformer.data('resize-base-w');
        var height = $transformer.data('resize-base-h');
        var ar = width / height;

        // calculate min padding
        var padding = $canvas.outerWidth() * this.padding;

        // resize based ond the direction
        switch (direction){
            case 'br':
                var newW = width - x;
                newW = newW < 10 ? 10 : newW;
                newW = left + newW + padding > $canvas.outerWidth() ? $canvas.outerWidth() - left - padding : newW;
                newW = top + newW / ar + padding > $canvas.outerHeight() ? ($canvas.outerHeight() - top - padding) * ar : newW;
                var newH = newW / ar;
                var newX = left;
                var newY = top;
                break;
            case 'bl':
                var newW = width + x;
                newW = newW < 10 ? 10 : newW;
                newW = left - x - padding < 0 ? width + left - padding : newW;
                newW = top + newW / ar + padding > $canvas.outerHeight() ? ($canvas.outerHeight() - top - padding) * ar : newW;
                var newH = newW / ar;
                var newX = left - (newW - width);
                var newY = top;
                break;
            case 'tr':
                var newW = width - x;
                newW = newW < 10 ? 10 : newW;
                newW = left + newW + padding > $canvas.outerWidth() ? $canvas.outerWidth() - left - padding : newW;
                newW = top - (newW / ar - height) - padding < 0 ? (height + top - padding) * ar : newW;
                var newH = newW / ar;
                var newX = left;
                var newY = top - (newH - height);
                break;
            case 'tl':
                var newW = width + x;
                newW = newW < 10 ? 10 : newW;
                newW = left - x - padding < 0 ? width + left - padding : newW;
                newW = top - (newW / ar - height) - padding < 0 ? (height + top - padding) * ar : newW;
                var newH = newW / ar;
                var newX = left - (newW - width);
                var newY = top - (newH - height);
                break;
        }

        // check background
        if (!this.isBackgroundAllowed(newX, newY, newW, newH)){
            return;
        }

        // update
        $(this.ui.transformer).css({
            left: newX + 'px',
            top: newY + 'px',
            width: newW + 'px'
        });

        // handlers
        this.trigger('resize', [newX, newY, newW]);

    },
    moveCommit: function(){

        var $transformer = $(this.ui.transformer);

        $transformer.data('resize-base-initiated', false);
        $transformer.data('resize-base-x', null);
        $transformer.data('resize-base-y', null);
        $transformer.data('resize-base-w', null);
        $transformer.data('resize-base-h', null);

    },
    resizeCommit: function(){

        var $transformer = $(this.ui.transformer);

        $transformer.data('resize-base-initiated', false);
        $transformer.data('resize-base-x', null);
        $transformer.data('resize-base-y', null);
        $transformer.data('resize-base-w', null);
        $transformer.data('resize-base-h', null);

    },
    setPosition: function(x, y, width){

        $(this.ui.transformer).css({
            left: Math.round(x) + 'px',
            top: Math.round(y) + 'px'
        });

        if (width) {
            $(this.ui.transformer).css({
                width: Math.round(width) + 'px'
            });
            // handlers
            this.trigger('resize', [Math.round(x), Math.round(y), Math.round(width)]);
        }else{
            // handlers
            this.trigger('move', [Math.round(x), Math.round(y), Math.round(width)]);
        }

    },
    setScale: function(scale){

        this.scale = scale;

    },
    setColorRestriction: function (color, image) {

        this.colorRestriction = color;
        this.colorRestrictionImage = image;

        this.colorRestrictionCanvas = this.createWallpaperCanvas();

    },
    createWallpaperCanvas: function () {

        var self = this;

        // get wallpaper size
        var $editor = $(this.ui.canvas);

        // create canvas and image
        var canvas = document.createElement('canvas');
        var img = new Image();
        img.src = this.colorRestrictionImage;

        $(img).on('load', function (){

            var width = $editor.outerWidth();
            var height = $editor.outerHeight();

            canvas.width = width;
            canvas.height = height;
            var ar = width / height;
            var imgAr = img.width / img.height

            if (ar > img.width / img.height){
                var imgW = width;
                var imgH = width / imgAr;
            }else {
                var imgW = height * imgAr;
                var imgH = height;
            }

            canvas.getContext('2d').drawImage(img, (width - imgW) / 2, (height - imgH) / 2, imgW, imgH);

        });

        return canvas;

    },
    isCurrentPositionValid: function(){

        // elements
        var $canvas = $(this.ui.canvas);
        var $logo = $(this.ui.transformerImg);
        var $transformer = $(this.ui.transformer);

        // coordinates
        var x = parseFloat($transformer.css('left'));
        var y = parseFloat($transformer.css('top'));
        var width = $logo.width();
        var height = $logo.height();

        // calculate min padding size;
        var padding = $canvas.outerWidth() * this.padding;

        // do not allow to pass the edge values
        if (x < padding || x + width >= $canvas.outerWidth() - padding){
            return false;
        }
        if (y < padding || y + height >= $canvas.outerHeight() - padding){
            return false;
        }

        // check background
        if (!this.isBackgroundAllowed(x, y, width, height)){
            return false;
        }

        return true;

    },
    isBackgroundAllowed: function(x, y, width, height) {

        if (!this.colorRestriction){
            return true;
        }

        var step = 20;
        for(var x1 = x; x1 < x + width; x1 = x1 + step){
            if (!this.isColorAllowed(this.colorRestrictionCanvas.getContext('2d').getImageData(x1, y, 1, 1).data) ||
                !this.isColorAllowed(this.colorRestrictionCanvas.getContext('2d').getImageData(x1, y + height, 1, 1).data)){
                return false;
            }
        }
        for(var y1 = y; y1 < y + height; y1 = y1 + step){
            if (!this.isColorAllowed(this.colorRestrictionCanvas.getContext('2d').getImageData(x, y1, 1, 1).data) ||
                !this.isColorAllowed(this.colorRestrictionCanvas.getContext('2d').getImageData(x + width, y1, 1, 1).data)){
                return false;
            }
        }

        return true;

    },
    isColorAllowed: function (data) {

        var allowed = this.hexToRgb(this.colorRestriction);

        if (data[0] === 0 || data[0] === allowed.r && data[1] === allowed.g && data[2] === allowed.b){
            return true;
        }

        return false;

    },
    hexToRgb: function (hex) {

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;

    },
    on: function(event, callback){

        if (typeof this.handlers[event] !== 'undefined'){
            this.handlers[event].push(callback);
        }

    },
    trigger: function(event, args){

        if (typeof this.handlers[event] !== 'undefined'){
            for (var z in this.handlers[event]){
                if (!this.handlers[event].hasOwnProperty(z)){
                    continue;
                }
                this.handlers[event][z].apply(this, args);
            }
        }

    }
};